// components/KPICard.js – upgraded version
import React from 'react';
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { COLORS } from "../constants/ui";

const KPICard = ({ title, value, IconComponent, icon, color = "#F1A028", linkTo, detail }) => {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      whileHover={{ y: -2, transition: { duration: 0.2 } }}
      whileTap={{ scale: 0.97 }}
      onClick={() => linkTo && navigate(linkTo)}
      style={{
        cursor: linkTo ? "pointer" : "default",
        background: COLORS.accentInk,
        borderRadius: 12,
        padding: "0.9rem 1.1rem",
        border: "1px solid rgba(241,160,40,0.18)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.18)",
        color: "white",
        minWidth: 0,
        flex: 1,
      }}
    >
      {/* Label and number on one line each, icon inline rather than stacked —
          a KPI is a number with a name, and the icon was adding a whole row of
          height without adding information. */}
      <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 2 }}>
        {IconComponent ? (
          <IconComponent size={14} color={COLORS.accent} />
        ) : icon ? (
          <span style={{ display: "inline-flex", color: "#a9ddf5" }}>{icon}</span>
        ) : null}
        <div style={{ fontSize: "0.76rem", fontWeight: 600, opacity: 0.85, letterSpacing: "0.01em" }}>
          {title}
        </div>
      </div>

      <div style={{ fontSize: "1.9rem", fontWeight: 800, color: "#fff", lineHeight: 1.1 }}>
        {value}
      </div>
      {detail ? (
        <div
          style={{
            marginTop: '0.3rem',
            fontSize: '0.72rem',
            fontWeight: 600,
            lineHeight: 1.45,
            opacity: 0.92,
            color: 'rgba(255,255,255,0.95)',
          }}
        >
          {detail}
        </div>
      ) : null}
    </motion.div>
  );
};

export default KPICard;
